// src/app/core/interceptors/auth.interceptor.ts
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AuthenticationService } from '../authentication/authentication.service';
import { APP_CONSTANTS } from '../../constants/app.constants';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthenticationService);
  const token = authService.getCookie(APP_CONSTANTS.COOKIE_NAMES.AUTH_TOKEN);
  const isApiUrl = req.url.startsWith(environment.API_ENDPOINT);

  if (token && isApiUrl) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    });
  } else {
    if (!token && isApiUrl) {
      console.warn('AuthInterceptor: No token found for API request:', req.url);
    }
  }

  return next(req);
};
